import { useMutation, useQuery } from '@tanstack/react-query'
import { gql } from 'graphql-request'
import { gqlClient } from '@/lib/graphql'

const SYNC = gql`
  mutation SyncBookToGithub($bookId: ID!) {
    syncBookToGithub(input: { bookId: $bookId }) {
      book { id githubRepoUrl }
      errors
    }
  }
`

const STATUS = gql`
  query SyncStatus($slug: String!) {
    book(slug: $slug) {
      id
      orphanedCount
      audioReviewCount
      conflictCount
      lastPullSummary
      lastSyncedAt
    }
  }
`

interface SyncResult {
  syncBookToGithub: {
    book: { id: string; githubRepoUrl: string | null } | null
    errors: string[]
  }
}

export interface SyncStatusData {
  id: string
  orphanedCount: number
  audioReviewCount: number
  conflictCount: number
  lastPullSummary: string | null
  lastSyncedAt: string | null
}

export function useSyncBook() {
  return useMutation({
    mutationFn: async (bookId: string) => {
      const res = await gqlClient.request<SyncResult>(SYNC, { bookId })
      if (res.syncBookToGithub.errors.length) throw new Error(res.syncBookToGithub.errors.join(', '))
      return res.syncBookToGithub
    },
  })
}

export function useSyncStatus(slug: string, enabled = true) {
  return useQuery({
    queryKey: ['sync-status', slug],
    enabled,
    queryFn: async () =>
      (await gqlClient.request<{ book: SyncStatusData }>(STATUS, { slug })).book,
    refetchInterval: enabled ? 4000 : false,
  })
}
